/* app/js/src/components/calendar/expandable/calendar-expandable-editable-time/calendar-expandable-editable-time.component.scss */
.edit-time-container {
  display: flex;
}
.lock-icon {
  margin-right: 5px;
}
.time-display {
  cursor: pointer;
}
.edit-border {
  border: solid 1px #232f3a;
  border-radius: 3px;
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.input-field {
  position: relative;
  background-color: rgba(226, 232, 241, 0);
  height: 22px;
  border: 0;
  font-size: 11px;
  font-family: "Open Sans", sans-serif;
  text-align: center;
  outline: none;
}
.input-width {
  width: 17px;
}
.ms-input-width {
  width: 23px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
/*# sourceMappingURL=calendar-expandable-editable-time.component.css.map */
